// https://vuelidate.js.org/#sub-builtin-validators

export const getValidationMessages = (
  validStateData: any,
  maskExample?: string
) => {
  let msg = null;
  if (!validStateData) return null;

  const params = validStateData.$params;
  'url' in validStateData && !validStateData.url
    ? maskExample
      ? (msg = `введите корректный адрес, напр.: ${maskExample}`)
      : msg = `некорректный адрес сайта`
    : null;
  'workDateBefore' in validStateData && !validStateData.workDateBefore
    ? (msg = 'Дата увольнения не может быть раньше даты принятия на работу')
    : null;
  'maxValue' in validStateData && !validStateData.maxValue
    ? (msg = `минимальное значение ${params.maxValue.max}`)
    : null;
  'minValue' in validStateData && !validStateData.minValue
    ? (msg = `минимальное значение ${params.minValue.min}`)
    : null;
  'between' in validStateData && !validStateData.between
    ? (msg = `значение должно быть от ${params.between.min} до ${params.between.max}`)
    : null;
  'maxLength' in validStateData && !validStateData.maxLength
    ? (msg = `не соотвествует максимальное кол-во символов`)
    : null;
  'minLength' in validStateData && !validStateData.minLength
    ? (msg = `не соотвествует минимальное кол-во символов`)
    : null;

  'decimal' in validStateData && !validStateData.decimal
    ? (msg = `только десятичные числа.`)
    : null;
  'integer' in validStateData && !validStateData.integer
    ? (msg = `только целые числа`)
    : null;
  'numeric' in validStateData && !validStateData.numeric
    ? (msg = `только цифры`)
    : null;
  'alpha' in validStateData && !validStateData.alpha
    ? (msg = `только символы алфавита`)
    : null;
  'alphaNum' in validStateData && !validStateData.alphaNum
    ? (msg = `только буквенно-цифровые символы`)
    : null;
  'mask' in validStateData && !validStateData.mask
    ? maskExample
      ? (msg = `введите корректное значение, напр.: ${maskExample}`)
      : msg = `некорректный формат`
    : null;
  'validateSnils' in validStateData && !validStateData.validateSnils
    ? (msg = `введите корректное значение, напр.: '099 818 069 39'`)
    : null;

  'required' in validStateData && !validStateData.required
    ? (msg = 'поле обязательно для заполнения')
    : null;
  

  return msg;
};



// WEBPACK FOOTER //
// ./src/tools/declare/global/utils/validationMessages.ts